import { useEffect, useState } from "react";
import { getCompanyAccessName } from "../App";

const useFetchConfig = (config, inputCompanyAccessName) => {
  const resolvedCompanyAccessName =
    inputCompanyAccessName || getCompanyAccessName();

  const [configSettings, setConfigSettings] = useState(null);
  const [content, setContent] = useState({
    navbarItems: [],
    activeButton: null,
    widgetItems: [],
  });

  useEffect(() => {
    const fetchConfig = async () => {
      if (!resolvedCompanyAccessName) {
        return;
      }

      try {
        const data =
          config ??
          (await (
            await fetch(
              process.env.API_BASE_URL + `/pcw/${resolvedCompanyAccessName}/config`,
              {
                mode: "cors",
              }
            )
          ).json());

        const navbarItems = Array.isArray(data.navbarItems)
          ? data.navbarItems
          : [];
        const widgetDisplayLimit =
          data.widgetDisplayLimit || navbarItems.length;

        const widgetItems = navbarItems.slice(0, widgetDisplayLimit);

        setConfigSettings({
          ...data,
          pageSize: data.pageSize,
        });

        setContent({
          navbarItems: navbarItems.map((item) => item.name || "Unnamed Item"),
          activeButton: data.defaultActiveButton || null,
          widgetItems,
        });
      } catch (error) {
        setConfigSettings(null);
      }
    };

    fetchConfig();
  }, [resolvedCompanyAccessName, config]);

  return { configSettings, setConfigSettings, content, setContent };
};

export default useFetchConfig;
